import React from 'react';

const TransactionsHead: React.FC = React.memo(() => {
  return <div style={{ textAlign: 'center' }}>Transactions</div>;
});

export default TransactionsHead;
